// extracted by mini-css-extract-plugin
var _1 = "Register_checkbox__Qji6o";
var _2 = "Register_checkboxLabel__35ZV2";
var _3 = "Register_checkboxWrapper__t13Ak";
var _4 = "Register_registrationDisabledText__b8GIs";
export { _1 as "checkbox", _2 as "checkboxLabel", _3 as "checkboxWrapper", _4 as "registrationDisabledText" }
